import { useState, useEffect } from 'react';
import componentNotifier from '../services/wss/ComponentNotifier';
import calendarEngine from './Core/CalendarEngine';

const _engineName = 'CalendarEngine';

/**
 * useCalendar — observer hook for CalendarEngine.
 * Subscribes to dataChanged, triggers repaint.
 * All state lives in calendarEngine/calendarCache — hook is a pure observer
 * (Development.Patterns rk=f03ae8b6, no business logic in hooks).
 * "Ringing" state is computed via event.isRinging() (CalEventObj) — no
 * separate state to read here, survives page refresh.
 * @returns {{
 *   upcoming: CalEventObj[],
 *   visible: CalEventObj[],
//  *   dismiss: function(string): void,
//  *   minimize: function(string): void,
//  *   show: function(string): void,
 * }}
 */
export function useCalendar() {
    const [, forceRepaint] = useState(0);

    useEffect(() => {
        const repaint = () => forceRepaint((n) => n + 1);
        return componentNotifier.subscribe('dataChanged', repaint);
    }, []);

    return {
        upcoming: calendarEngine.getUpcoming(),
        visible: calendarEngine.getVisible(),
        // dismiss: calendarEngine.dismiss,
        // minimize: calendarEngine.minimize,
        // show: calendarEngine.show,
    };
}
